import React, { useEffect, useState } from 'react';
import { researchNavigate } from '../desk/researchNavigation';
import { BriefIssue } from './BriefIssue';
import './brief.css';

const TIERS = [
  { value: '', label: 'All' },
  { value: 'daily', label: 'Daily' },
  { value: 'deep', label: 'Deep' },
  { value: 'weekly', label: 'Weekly' },
];

export function issueTitle(issue) {
  if (issue.title) return issue.title;
  const tier = issue.tier ? issue.tier.charAt(0).toUpperCase() + issue.tier.slice(1) : 'Brief';
  return `${tier} · ${issue.date || ''}`;
}

export default function BriefArchive() {
  const [tier, setTier] = useState('');
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let disposed = false;
    const controller = new AbortController();
    (async () => {
      try {
        setLoading(true); setError('');
        const q = tier ? `?tier=${encodeURIComponent(tier)}` : '';
        const res = await fetch(`/api/research/brief/issues${q}`, { signal: controller.signal, cache: 'no-store', headers: { "X-API-Key": process.env.REACT_APP_API_KEY || "" } });
        if (!res.ok) throw new Error('The brief store is unavailable. Please retry.');
        const data = await res.json();
        if (!disposed) setIssues(data.issues || []);
      } catch (e) {
        if (!disposed && e.name !== 'AbortError') setError(e.message || 'Failed to load issues.');
      } finally {
        if (!disposed) setLoading(false);
      }
    })();
    return () => { disposed = true; controller.abort(); };
  }, [tier]);

  return <div className="mb"><div className="mb-col">
    <div className="mb-cover-kicker">AEON Research</div>
    <h1 className="mb-serif" style={{ fontWeight: 900, fontSize: 'clamp(28px,4vw,44px)', margin: '0 0 8px' }}>Carlos's Market Brief</h1>
    <p style={{ color: '#4b5563', maxWidth: '70ch' }}>Crypto, equities and macro through one desk's lens — what moved, why, and what comes next.</p>

    <div className="mb-tier-tabs" role="group" aria-label="Filter by tier">
      {TIERS.map(t => <button key={t.value} type="button" aria-pressed={tier === t.value} onClick={() => setTier(t.value)}>{t.label}</button>)}
    </div>

    {loading && <div className="mb-empty">Loading issues…</div>}
    {error && <div className="mb-error">{error}</div>}
    {!loading && !error && issues.length === 0 && <div className="mb-empty">No published issues yet. Check back soon.</div>}
    {!loading && !error && issues.length > 0 && <ul className="mb-issue-list">
      {issues.map(issue => <li key={issue.slug}>
        <a className="mb-issue-row" href={`/research/brief/${issue.slug}`} onClick={e => { e.preventDefault(); researchNavigate(`/research/brief/${issue.slug}`); }}>
          <div className="mb-issue-meta">
            <span className="mb-tier-pill">{issue.tier}</span>
            <span>{issue.date}</span>
            {issue.stance && <span>Stance: {issue.stance.direction}{issue.stance.grade ? ` · ${issue.stance.grade}` : ''}</span>}
            {issue.number && <span>Issue No. {issue.number}</span>}
          </div>
          <div className="mb-issue-title">{issueTitle(issue)}</div>
        </a>
      </li>)}
    </ul>}

    <footer className="mb-footer"><p>Market commentary, not investment advice.</p></footer>
  </div></div>;
}

// Re-exported for admin preview convenience.
export { BriefIssue };
